import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import ListingSection from '../ListingSection';
import ListingSectionItem from '../ListingSectionItem';

const SectionDescriptionMaybeLoadingSkeleton = () => (
  <ListingSection>
    <ListingSectionItem>
      <Skeleton height="180px" sx={{ borderRadius: 2 }} variant="rounded" width="100%" />
    </ListingSectionItem>
  </ListingSection>
);

export default SectionDescriptionMaybeLoadingSkeleton;